export default __webpack_public_path__ + "static/media/B_Imo.2b8277c6.jpg";